import React from "react";
import { ClipboardCheckIcon, EyeIcon, LayoutGridIcon, LineChartIcon, MessagesSquareIcon, BoxIcon } from "lucide-react";
import { SectionCta } from "./CtaButton";
import { tools } from "../data/content";
const iconMap: Record<(typeof tools)[number]['icon'], BoxIcon> = {
  checklist: ClipboardCheckIcon,
  observation: EyeIcon,
  visual: LayoutGridIcon,
  partner: MessagesSquareIcon,
  tracker: LineChartIcon
};
export function Tools() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-labelledby="tools-title" data-id="element-259" data-mp="2040htk35ckg1">
      <div className="mx-auto max-w-3xl" data-id="element-260" data-mp="244answqxvauw">
        <h2 id="tools-title" className="text-center text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-261" data-mp="1qdfa975hw5kz">
          PRACTICAL TOOLS INCLUDED IN THE COLLECTION
        </h2>
        <p className="mt-4 text-center text-[17px] leading-relaxed text-muted" data-id="element-262" data-mp="1va5tu4gidjb5">
          Alongside the six volumes, you’ll receive practical resources designed to help you organize your planning work.
        </p>

        <ul className="mt-10 divide-y divide-navy/10" data-id="element-263" data-mp="2p1e8bqln68fl">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 py-5" data-id="element-264" data-mp="2l13rtk083zmh">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-teal-light text-teal" data-id="element-265" data-mp="2yr787ucf8z40">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-266" data-mp="2u0ifkbp09w3a" />
                </span>
                <div data-id="element-267" data-mp="38p56lanzwcac">
                  <h3 className="text-[18px] font-extrabold text-ink" data-id="element-268" data-mp="38olqlzhwnxyy">{t.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-muted" data-id="element-269" data-mp="33rd5bq1gndth">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-6 text-center text-sm italic text-muted" data-id="element-270" data-mp="3ho8qgguzkvpw">
          These are educational planning aids, not validated diagnostic or assessment instruments.
        </p>
        <SectionCta label="Get the complete collection" data-id="element-271" data-mp="1nctzxxu5is93" />
      </div>
    </section>;
}